<div [ngClass]="getCurrentCssClass()" class="banner-container">
  <div [ngClass]="getCloseCurrentCssClass()" class="banner-close">
    <app-ui-icon (click)="closeBanner()" color="var(--grey-1)" name="close" size="md"></app-ui-icon>
  </div>
  <div [ngClass]="getLabelCurrentCssClass()" class="banner-label">ANNONS</div>

  <div (renderEnded)="refreshed($event)" [dfpAd]="adConfig" [ngClass]="bannerCssClass" [ngStyle]="aspectRatioCssStyle"
       class="standard-dfp-banner"></div>
</div>
